import { type OrderQueueRow } from '@/features/reports/api';
import { TRANSACTIONS_COPY } from '@/features/reports/copy';
import { QUEUE_BUCKET } from '@/features/reports/tabs';

const COPY = TRANSACTIONS_COPY.orders;

/** "a-list-transactions-margin-month-2026-10-21.xlsx", as the API names the same file. */
export function exportFileName(parts: string[]): string {
    const day = new Date().toISOString().slice(0, 10);
    return `${['a-list-transactions', ...parts].map((p) => p.toLowerCase()).join('-')}-${day}.xlsx`;
}

/** "a-list-tax-quarter-2026-10-23.xlsx", as the API names the same file (ALS-90). */
export function taxExportFileName(period: string): string {
    const day = new Date().toISOString().slice(0, 10);
    return `a-list-tax-${period.toLowerCase()}-${day}.xlsx`;
}

/** What the order needs next, in the prototype's words: "Overdue 2 days", "Due today". */
export function nextAction(row: Pick<OrderQueueRow, 'bucket' | 'days'>): string {
    switch (row.bucket) {
        case QUEUE_BUCKET.Overdue:
            return COPY.next.overdue(row.days ?? 0);
        case QUEUE_BUCKET.Due:
            return COPY.next.due(row.days ?? 0);
        case QUEUE_BUCKET.InTransit:
            return COPY.next.inTransit;
        case QUEUE_BUCKET.AtCustoms:
            return COPY.next.atCustoms;
        default:
            return '';
    }
}
